// Kodeks 2026 — match section behavior
(function () {
  function init() {
    var grid = document.querySelector('.match-grid[data-unlock-count]');
    if (!grid) return;

    var count = parseInt(grid.getAttribute('data-unlock-count'), 10) || 4;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-match-id]'));
    if (!cards.length) return;

    // Fisher-Yates shuffle of indices, pick first `count` to unlock.
    var idx = cards.map(function (_, i) { return i; });
    for (var i = idx.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = idx[i]; idx[i] = idx[j]; idx[j] = tmp;
    }
    var unlock = {};
    for (var k = 0; k < Math.min(count, idx.length); k++) unlock[idx[k]] = true;

    cards.forEach(function (card, i) {
      var full = card.querySelector('.mc-full');
      var locked = card.querySelector('.mc-locked');
      if (unlock[i]) {
        card.classList.remove('locked');
        if (full) full.classList.remove('hidden');
        if (locked) locked.classList.add('hidden');
      } else {
        card.classList.add('locked');
        if (full) full.classList.add('hidden');
        if (locked) locked.classList.remove('hidden');
      }
    });
  }

  // Group filter (locked cards still filter, but stay locked)
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-group-filter]');
    if (!chip) return;
    var g = chip.getAttribute('data-group-filter');
    document.querySelectorAll('[data-group-filter]').forEach(function (c) {
      c.classList.toggle('active', c === chip);
    });
    document.querySelectorAll('[data-match-group]').forEach(function (m) {
      var show = g === 'ALL' || m.getAttribute('data-match-group') === g;
      m.style.display = show ? '' : 'none';
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
